export const AddonPackType = {
    USER: "USER",
    DATA_EXTRACTION: "DATA_EXTRACTION",
    WHATSAPP: "WHATSAPP",
    EMAIL: "EMAIL",
    STORAGE: "STORAGE",
    FLOW: "FLOW",
    MALAYSIA_SST: "MALAYSIA_SST",
    MULTI_CURRENCY: "MULTI_CURRENCY",
};
